import React, {useEffect, useState} from 'react';
import './skills.css';
import Fronend from './Frontend';
import Backend from './Backend';
import Databases from './Databases';
import DataPreprocess from './DataPreprocess';
import DevOps from './DevOps';
import Git from './Git';
import MachineLearning from './MachineLearning';
import Electronics from './Electronics';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const SkillItem = ({ children }) => (
  <div className="skill-item">
    {children}
  </div>
);

const Skills = () => {
    const [centerSlidePercentage, setCenterSlidePercentage] = useState(33.33);

    useEffect(() => {
      const handleResize = () => {
        // Adjust the centerSlidePercentage based on window width
        const windowWidth = window.innerWidth;
  
        if (windowWidth <= 576) {
          setCenterSlidePercentage(100); // For small screens, show one slide at a time
        } else if (windowWidth <= 992) {
          setCenterSlidePercentage(50); // For medium screens, show two slides at a time
        } else {
          setCenterSlidePercentage(33.33); // For large screens, show three slides at a time
        }
      };
  
      // Add an event listener for window resize
      window.addEventListener('resize', handleResize);
  
      // Initial adjustment
      handleResize();
  
      // Clean up the event listener when the component unmounts
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
  return (
    <section className="skills section" id="skills">
        <h2 className="section__title">Skills</h2>
        <span className="section__subtitle-edit">My technical level</span>
        <div className="skills__container container">
            <Carousel
                showArrows={true}
                infiniteLoop={true}
                showThumbs={false}
                emulateTouch={true}
                swipeable={true}
                showStatus={false} // disabling status indicator
                centerMode={true} // disabling center mode
                centerSlidePercentage={centerSlidePercentage} // percentage for viewing 3 tables
                interval={0} // disable scrol-lbar
            >
                <SkillItem>
                    <Electronics />
                </SkillItem>
                <SkillItem>
                    <Backend />
                </SkillItem>
                <SkillItem>
                    <Fronend />
                </SkillItem>
                <SkillItem>
                    <DataPreprocess />
                </SkillItem>
                <SkillItem>
                    <Git />
                </SkillItem>
                <SkillItem>
                    <DevOps />
                </SkillItem>
                <SkillItem>
                    <Databases />
                </SkillItem>
                <SkillItem>
                    <MachineLearning />
                </SkillItem>
            </Carousel>
        </div>
    </section>
  );
};

export default Skills;
